// ─── Backend (REACT_APP_API_BASE_URL) ────────────────────────────────────────
export const BACKEND_ENDPOINTS = {

  BASE_URL: `${process.env.REACT_APP_API_BASE_URL}/api`,
  AI_API_BASE_URL: process.env.REACT_APP_AI_BASE_URL,
  SEARCH_BASE_URL: `${process.env.REACT_APP_SEARCH_BASE_URL}/api`,

  // Auth
  ADD_NADRA_USERS: "/addNadraUsers",
  LOGIN: "/lawgptuserAuth",
  SIGN_UP: "/lawgptuserSignUp",
  VERIFY_EMAIL: "/verifyEmail",
  RESEND_VERIFICATION_EMAIL: "/resendVerificationEmail",
  EMAIL_VERIFICATION: "/emailVerification",
  RESET_PASSWORD: "/resetPassword",
  VERIFY_TOKEN: "/verifyToken",
  MARK_MODAL_SEEN: "/lawgptMarkModalSeen",

  // User
  GET_USER_PROFILE: "/getUserProfile",
  UPDATE_USER_PROFILE: "/users/profile/update",

  // Credits
  ADD_CREDITS: "/addCredits",
  DEDUCT_CREDITS: "/deductCredits",

  // Chat history (stored in backend, not AI service)
  GET_CHAT_HISTORY: "/get-chat-history",
  SAVE_CHAT_HISTORY: "/save-chat-history",

  // Bookmarks
  GET_BOOKMARK_GROUPS: "/getUserBookmarkGroups",
  CREATE_BOOKMARK_GROUP: "/createBookmarkGroup",
  RENAME_BOOKMARK_GROUP: "/renameBookmarkGroup",
  DELETE_BOOKMARK_GROUP: "/deleteBookmarkGroup",
  ADD_CASE_TO_GROUP: "/addCaseToGroup",
  ADD_STATUTE_TO_GROUP: "/addStatuteToGroup",
  ADD_CMS_DOC_TO_GROUP: "/addCmsDocToGroup",
  DELETE_CASE_OR_STATUTE_FROM_GROUP: "/deleteCaseOrStatuteFromGroup",
  DELETE_CMS_DOC_FROM_GROUP: "/deleteCmsDocFromGroup",
  MOVE_CASE_OR_STATUTE_BETWEEN_GROUPS: "/moveCaseOrStatuteBetweenGroups",
  UPDATE_NOTE: "/updateNote",
  REMOVE_NOTE: "/removeNote",

  // Case details
  GET_CASE_DETAILS: "/getCaseDetails",

  // Feedback
  LEGAL_CHAT_FEEDBACK: "/legalChat/v1/feedback",

  // Case management
  CASE_MANAGEMENT_LAWYERS: "/case-management/v1/lawyers",
  CASE_MANAGEMENT_CLIENTS: "/case-management/v1/clients",
  CASE_MANAGEMENT_CASES: "/case-management/v1/cases",
  CASE_MANAGEMENT_DOCUMENTS_BY_IDS: "/case-management/v1/documents/by-ids",
  CASE_MANAGEMENT_CHECK_INVITATION: "/case-management/v1/invitations/checkStatus",
  CASE_MANAGEMENT_INVITATIONS: "/case-management/v1/invitations",
  CASE_MANAGEMENT_INVITATIONS_EXISTING_USER: "/case-management/v1/invitations/existing-user",
  CASE_MANAGEMENT_USERS_SEARCH: "/users/search",
  CASE_MANAGEMENT_USERS: "/case-management/v1/users",

  // Users
  USERS_EMAILS: "/users/emails",

  // Complaint / Feedback
  STORE_COMPLAINT: "/storeComplaint",

  // Credits
  GET_CREDIT_HISTORY: "/getCreditHistory",

  // Legal Library
  LEGAL_LIBRARY_SEARCH: "/legal_library/search",
  LEGAL_TERMS_SUGGESTION: "/legalterms/suggestion",
  LEGAL_TERMS_SEARCH: "/legalterms/search",
  GET_USER_FAVORITES: "/getUserFavorites",
  GET_PDF_FROM_BLOB_STORAGE: "/legal_library/fetch_pdf",
  REMOVE_FAVORITE: "/removeFavorite",
  ADD_FAVORITE: "/addFavorite",
};

// ─── AI Chat service (REACT_APP_AI_BASE_URL) ─────────────────────
export const LEGAL_CHAT_ENDPOINTS = {
  HYBRID_CHAT: "/hybrid_chat",
  STATUTE_CHAT: "/statute_chat",
  CASE_CHAT: "/case_chat",
  BASE_CHAT: "/base_chat",
  STREAMING_CHAT: "/chat",
  GET_CHAT_HISTORY: "/get-chat-history",
  SAVE_CHAT_HISTORY: "/save-chat-history",
  CREATE_CHAT_SESSION: "/create-chat-session",
  UPDATE_CHAT_SESSION: "/update-chat-session",
  DELETE_CHAT_SESSION: "/delete-chat-session",
  GET_CHAT_SESSIONS: "/get-chat-sessions",
  // pin/unpin consolidated into UPDATE_CHAT_SESSION
};

// ─── Case law search ───────────────────────────
export const CASE_LAW_ENDPOINTS = {
  SEARCH: "/lawcases/search",
  FETCH_SUGGESTIONS: "/lawcases/suggestion",
  FACETS: "/lawcases/facets",
};

// ─── Statute search (SEARCH_BASE_URL) ──────────────────────
export const STATUTE_SEARCH_ENDPOINTS = {
  SEARCH: "/statutes/search",
  FETCH_SUGGESTIONS: "/statutes/suggestion",

};

// ─── JudgeGPT service (REACT_APP_AI_BASE_URL) ─────────────────────────
export const JUDGE_GPT_ENDPOINTS = {
  CASE_SEARCH: "/case_search",
  GET_INIT_INFO: "/get_init_info",
  GET_HISTORY: "/get_history",
  UPDATE_CHAT_TITLE: "/update_chat_title",
  DELETE_CHAT: "/delete_chat",
  PIN_UNPIN_CHAT: "/pin_unpin_chat",
  JUDGMENT_DOCUMENT: "/judgment_document",
  JUDGMENT_DATA: "/judgment_data",
  STATUE_SEARCH: "/statue_search",
  DOCUMENT_JUDGEMENT: "/judgment/document/stream?stream=true",
};

// ─── Document generation (REACT_APP_AI_BASE_URL) ──────────────────────
export const DOC_GEN_ENDPOINTS = {
  DELETE_APPLICATION: "/DeleteApplication",
  APPLICATION_HISTORY: "/HistoryApplication",
  DELETE_PETITION: "/DeletePetition",
  PETITION_HISTORY: "/HistoryPetition",
  UPDATE_PETITION: "/UpdatePetition",
  UPDATE_APPLICATION: "/UpdateApplication",
  GET_DOCUMENT_LIST: "/document/list",
  GET_DOCUMENT_SCHEMA: "/document/schema",
  GENERATE_DOCUMENT: "/document/generate",

};

// ─── Drafting history (REACT_APP_API_BASE_URL) ───────────────────────────────
export const DRAFTING_HISTORY_ENDPOINTS = {
  application: {
    SAVE: "/save-application-drafting-history",
    GET: "/get-application-drafting-history",
    UPDATE_FLAGS: "/update-application-drafting-history-flags",
    UPDATE_DOCUMENT: "/update-application-drafting-history-document",
    DELETE: "/delete-application-drafting-history",
  },
  petition: {
    SAVE: "/save-petition-drafting-history",
    GET: "/get-petition-drafting-history",
    UPDATE_FLAGS: "/update-petition-drafting-history-flags",
    UPDATE_DOCUMENT: "/update-petition-drafting-history-document",
    DELETE: "/delete-petition-drafting-history",
  },
  contract: {
    SAVE: "/save-contract-drafting-history",
    GET: "/get-contract-drafting-history",
    UPDATE_FLAGS: "/update-contract-drafting-history-flags",
    UPDATE_DOCUMENT: "/update-contract-drafting-history-document",
    DELETE: "/delete-contract-drafting-history",
  },
};

// ─── RAG Contract analysis (REACT_APP_AI_API_BASE_URL) ─────────────────
export const RAG_CONTRACT_ENDPOINTS = {
  CONTRACT_UPLOAD: "/contract/upload",
  ANALYSIS_SUMMARIZATION: "/contract/analysis/summarization",
  ANALYSIS_LEGALITY: "/contract/analysis/legality",
  ANALYSIS_BIAS: "/contract/analysis/bias",
  ANALYSIS_TEMPLATE: "/contract/analysis/template",
  CONTRACT_CHAT: "/contract/chat",
};

// ─── RAG Document chat (REACT_APP_AI_API_BASE_URL) ─────────────────────
export const RAG_CHAT_ENDPOINTS = {
  UPLOAD: "/rag/upload",
  DOCUMENTS: "/rag/documents",
  CHAT: "/rag/chat",
};

// ─── Document analysis (REACT_APP_AI_BASE_URL) ────────────────
export const DOC_ANALYSIS_ENDPOINTS = {
  UPLOAD: "/document-analysis/upload",
  DOCUMENT_CHAT: "/document-analysis/document-chat",
  GENERATE_DOCX: "/document-analysis/generate-docx",
  RECOMMENDATIONS: "/document-analysis/recommendations",
};
